module.exports = __webpack_public_path__ + "app/docrepo-invoice/filter-3R5oBh2H.html";